var React = require('react');

function DollarSignInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.8002 11.2C20.8002 8.54908 18.6512 6.40005 16.0002 6.40005C13.3492 6.40005 11.2002 8.54908 11.2002 11.2C11.2002 13.851 13.3492 16 16.0002 16M16.0002 16C18.6512 16 20.8002 18.1491 20.8002 20.8001C20.8002 23.451 18.6512 25.6001 16.0002 25.6001C13.3492 25.6001 11.2002 23.451 11.2002 20.8001M16.0002 16V4.80005M16.0002 16V27.2001","stroke":"#EC5344","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

DollarSignInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = DollarSignInline;

DollarSignInline.default = DollarSignInline;
